/* Moved from sections/hlth-benefits-panel.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var section = document.querySelector('.hlth-bp-' + SID + '');
        if (!section) return;

        /* ── Scroll dots + fade edge ── */
        var track = section.querySelector('.hlth-bp-track');
        var fade = document.getElementById('hlth-bp-fade-' + SID + '');
        var dots = section.querySelectorAll('.hlth-bp-dot');
        var cards = section.querySelectorAll('.hlth-bp-card');

        function updateDots() {
          if (!track || !cards.length || !dots.length) return;
          var scrollLeft = track.scrollLeft;
          var cardWidth = cards[0].offsetWidth + 16;
          var activeIndex = Math.round(scrollLeft / cardWidth);
          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === activeIndex);
          });
        }

        var prevBtn = document.getElementById('hlth-bp-prev-' + SID + '');
        var nextBtn = document.getElementById('hlth-bp-next-' + SID + '');

        function updateFade() {
          if (!track) return;
          var atStart = track.scrollLeft <= 10;
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
          if (fade) fade.classList.toggle('is-hidden', atEnd);
          if (prevBtn) prevBtn.classList.toggle('is-hidden', atStart);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', atEnd);
        }

        function scrollByCard(dir) {
          if (!track || !cards.length) return;
          var cardWidth = cards[0].offsetWidth + 16;
          track.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function() { scrollByCard(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function() { scrollByCard(1); });

        if (track) {
          track.addEventListener('scroll', function() {
            updateDots();
            updateFade();
          }, { passive: true });
          updateFade();
        }

        dots.forEach(function(dot) {
          dot.addEventListener('click', function() {
            var idx = parseInt(dot.dataset.index, 10);
            var card = cards[idx];
            if (card && track) {
              track.scrollTo({ left: card.offsetLeft - 24, behavior: 'smooth' });
            }
          });
        });

        /* ── Review modal ── */
        var overlay = document.getElementById('hlth-bp-modal-' + SID + '');
        if (overlay && overlay.parentNode !== document.body) {
          document.body.appendChild(overlay);
        }
        var modal = overlay.querySelector('.hlth-bp-modal');
        var headingEl = modal.querySelector('.hlth-bp-modal__heading');
        var quoteEl = modal.querySelector('.hlth-bp-modal__quote');
        var reviewerEl = modal.querySelector('.hlth-bp-modal__reviewer');
        var closeBtn = modal.querySelector('.hlth-bp-modal__close');

        section.querySelectorAll('.hlth-bp-card__review').forEach(function(preview) {
          preview.addEventListener('click', function(e) {
            e.stopPropagation();
            headingEl.textContent = preview.dataset.reviewHeading;
            quoteEl.textContent = '\u201C' + preview.dataset.reviewText + '\u201D';
            reviewerEl.textContent = preview.dataset.reviewName ? '\u2014 ' + preview.dataset.reviewName : '';
            overlay.classList.add('is-open');
          });
        });

        function closeModal() {
          overlay.classList.remove('is-open');
        }

        closeBtn.addEventListener('click', closeModal);
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) closeModal();
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-benefits-panel')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-benefits-panel').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_benefits_panel) return;
      w.__hlthJs_hlth_benefits_panel = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
